import Image from "next/legacy/image"
import React from "react"

type IconProps = {
  src: string
  alt: string
}

export const Icon = (props: IconProps) => {
  const { src, alt } = props
  return <Image src={src} alt={alt} width={16} height={16} layout="fixed" />
}
